import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Checkout.title',
    description: 'Checkout label',
    defaultMessage: 'Checkout',
  },
  expressTitle: {
    id: 'Checkout.expressTitle',
    description: 'Express checkout label',
    defaultMessage: 'Express Checkout',
  },
  shippingInfoTitle: {
    id: 'Checkout.shippingInfoTitle',
    description: 'Shipping info title',
    defaultMessage: 'Shipping Info',
  },
  defaultErrorMessage: {
    id: 'Checkout.defaultErrorMessage',
    description: 'Default place order message error',
    defaultMessage:
      'We’re running into a technical issue, please refresh your page and try again in a few minutes. Contact customer service for immediate assistance at 1-888-848-0965.',
  },
  noShippingAddress: {
    id: 'Checkout.noShippingAddress',
    defaultMessage: 'Shipping address has not been selected',
  },
  noBillingAddress: {
    id: 'Checkout.noBillingAddress',
    defaultMessage: 'Billing address has not been selected',
  },
  noShippingMethods: {
    id: 'Checkout.noShippingMethods',
    defaultMessage: 'Delivery methods has not been selected for all products',
  },
  paymentError: {
    id: 'Checkout.paymentError',
    defaultMessage: 'Please verify that your payment and/or shipping information is correct.',
  },
  paymentDataMissingError: {
    id: 'Checkout.paymentDataMissingError',
    defaultMessage: 'Credit Card data is invalid',
  },
  errorTitle: {
    id: 'Checkout.errorTitle',
    defaultMessage: 'Order Could not be processed',
  },
  shippingAddressError: {
    id: 'Checkout.shippingAddressError',
    defaultMessage: 'There is a problem with your address',
  },
  billingAddressError: {
    id: 'Checkout.billingAddressError',
    defaultMessage: 'There is a problem with your address',
  },
  zipInvalidError: {
    id: 'Checkout.zipInvalidError',
    description: 'Invalid Zip code',
    defaultMessage: 'Zip is not valid for the state.',
  },
  addressUnexpectedError: {
    id: 'Checkout.addressUnexpectedError',
    description: 'Unexpected error with the address',
    defaultMessage:
      'Something went wrong saving your shipping address, please try again',
  },
  poBoxAddressError: {
    id: 'Checkout.poBoxAddressError',
    description: 'PO Box address error',
    defaultMessage:
      'We do not ship to P.O. Boxes. Please provide a different shipping address to continue.',
  },
  billingAddressUnexpectedError: {
    id: 'Checkout.billingAddressUnexpectedError',
    description: 'Unexpected error with the billing address',
    defaultMessage:
      'Something went wrong saving your billing address, please try again',
  },
  cardTokenizationError: {
    id: 'Checkout.cardTokenizationError',
    description: 'Unexpected error with the credit card tokenization',
    defaultMessage:
      'Something went wrong trying to pay with this credit card. Please try with another card.',
  },
  giftCardOnlyPaymentError: {
    id: 'Checkout.giftCardOnlyPaymentError',
    description: 'Unexpected error with the giftcard only payment',
    defaultMessage:
      'Something went wrong trying to pay with this giftcards. Please try again.',
  },
  giftCardDeclinedPaymentError: {
    id: 'Checkout.giftCardDeclinedPaymentError',
    description: 'Payment error for declined Gift Card',
    defaultMessage:
      'One or more of your gift cards were declined. Please try again.',
  },
  shippingAddressStateNotAllowed: {
    id: 'Checkout.shippingAddressStateNotAllowed',
    description: 'Shipping address state not allowed',
    defaultMessage:
      'Thank you for your interest in Purple. Unfortunately, we cannot ship to the address you have selected. We are only able to ship to the United States, excluding US territories and APO, FPO, and DPO addresses. To order in Canada, please visit',
  },
  itemNotDeliverableError: {
    id: 'Checkout.DeliveryMethods.itemNotDeliverableError',
    description:
      'Error message when items are not deliverables to a certain address',
    defaultMessage:
      'Please call 888-848-0248 to place this order. Customized shipping is needed to ship this mattress to your location.',
  },
  deliveryMethodsError: {
    id: 'Checkout.DeliveryMethods.deliveryMethodsError',
    description: 'Generic error message for delivery methods',
    defaultMessage:
      'Something went wrong loading the delivery methods, please try again or refresh the page.',
  },
  accountLoginLinkBlockTitle: {
    id: 'Checkout.accountLoginLinkBlockTitle',
    description: 'Account Login link block title',
    defaultMessage:
      'Have an account?',
  },
  truemedPaymentError: {
    id: 'Checkout.truemedPaymentError',
    description: 'Truemed payment error',
    defaultMessage:
      'Something went wrong with Truemed, please try to place the order again',
  }
});
